import { TimeOfDay } from '../filtersTypes';

export function getButtonProperties(
  timeOfDay: TimeOfDay | null,
): { text: string; value: number }[] {
  switch (timeOfDay) {
    case TimeOfDay.MORNING:
      return [
        {
          text: '6 AM',
          value: 6,
        },
        {
          text: '7 AM',
          value: 7,
        },
        {
          text: '8 AM',
          value: 8,
        },
        {
          text: '9 AM',
          value: 9,
        },
        {
          text: '10 AM',
          value: 10,
        },
        {
          text: '11 AM',
          value: 11,
        },
      ];
    case TimeOfDay.AFTERNOON:
      return [
        {
          text: '12 PM',
          value: 12,
        },
        {
          text: '1 PM',
          value: 13,
        },
        {
          text: '2 PM',
          value: 14,
        },
        {
          text: '3 PM',
          value: 15,
        },
        {
          text: '4 PM',
          value: 16,
        },
        {
          text: '5 PM',
          value: 17,
        },
      ];
    case TimeOfDay.EVENING:
      return [
        {
          text: '6 PM',
          value: 18,
        },
        {
          text: '7 PM',
          value: 19,
        },
        {
          text: '8 PM',
          value: 20,
        },
        {
          text: '9 PM',
          value: 21,
        },
        {
          text: '10 PM',
          value: 22,
        },
        {
          text: '11 PM',
          value: 23,
        },
      ];
    default:
      return [];
  }
}
